var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.412 6.007a.403.403 0 0 0-.403.404v5.302c0 .223.18.403.403.403h5.303c.222 0 .403-.18.403-.403V6.41a.403.403 0 0 0-.403-.404H6.412Zm-1.953.404c0-1.08.875-1.954 1.953-1.954h5.303c1.079 0 1.953.875 1.953 1.954v5.302a1.953 1.953 0 0 1-1.953 1.953H6.412a1.953 1.953 0 0 1-1.953-1.953V6.41Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.287 1.882a.403.403 0 0 0-.403.404v5.302a.403.403 0 0 0 .403.403h.59a.775.775 0 1 1 0 1.55h-.59A1.953 1.953 0 0 1 .334 7.588V2.286A1.953 1.953 0 0 1 2.287.332H7.59a1.953 1.953 0 0 1 1.953 1.954v.589a.775.775 0 0 1-1.55 0v-.59a.403.403 0 0 0-.403-.403H2.287Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.5b88c13e.svg";
export { ForwardRef as ReactComponent };